export async function push_appPoint(api, uId) {
  console.log("push.js start!")
  // 앱다운로드 감사포인트 푸시
  let pushMessages = 
  {
    userId: uId,
    title: "엔타비 첫 방문을 환영합니다",
    content: "10,000P가 지급되었습니다. 즐거운 여행 되세요!",
    linkURL: "https://ntabi.co.kr/",
    imageURL:"https://ntabi.co.kr/IMGs/pushImgs/push_ntabi.png"
    //pushType: "appPoint",
  };

  try 
  {
    const res = await api("api/pushSend01", {
      param: 
      [
        { messages: pushMessages },
      ],
    });
    console.log("Push API Response:", res);   // res.data가 아니라 res 자체가 데이터임
    return res;  // 이미 data를 리턴받고 있으므로 그대로 반환
  } 
  catch (error) 
  {
    console.error("Push API Error:", error);
    throw error;
  }
}

export async function insPushHistory(api, ap) {
  let resInsert = ""
  // 푸시발송이력저장
  let insPushHistory = await api("/api/insPushHistory", { param: 
    [
      ap[0], ap[1], ap[2], ap[3], ap[4], ap[5], ap[6], ap[7], ap[8], ap[9], ap[10] 
    ] 
  });
  
  if(insPushHistory.affectedRows > 0) 
  {
    resInsert = "Y"
  }
  else 
  {
    resInsert = "N"
  }

  return resInsert;
}


export async function insPushHistory_man(api, ap) {
  let resInsert = ""
  // 푸시발송이력저장
  let insPushHistory = await api("/api/insPushHistory_man", { param: 
    [
      ap[0], ap[1], ap[2], ap[3], ap[4], ap[5], ap[6], ap[7], ap[8], ap[9] 
    ] 
  });
  
  if(insPushHistory.affectedRows > 0) 
  {
    resInsert = "Y"
  }
  else 
  {
    resInsert = "N"
  }

  return resInsert;
}